import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StorageService } from '../storage/storage.service';

export interface ImageLinksPayload {
  imagesLinks?: string;
}
export interface GoToLoginOptions {
  isAsm?: boolean;
  navigate?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  baseSiteId: any;
  image: any;
  imgLinks: Array<string> = [];

  constructor(
    protected meta: Meta,
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    protected storageService: StorageService,
    private occEndpointsService: OccEndpointsService,
    private router: Router
  ) {}

  getConfigurations(): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('fields', 'DEFAULT');

    const httpOptions = {
      headers: this.headers,
      params: httpParams,
    };

    return this.http.get(this.occEndpointsService.buildUrl(`/getRegionConfig`), httpOptions).pipe(
      map((data) => data),
      catchError(this.errorHandlr)
    );
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  setOAuthRedirectUri(businessType?: string, country?: string, lang?: string): void {
    this.storageService.setSessionStorageItem('ShimanoBusinessType', businessType ?? '');
    this.storageService.setSessionStorageItem('ShimanoCountry', country ?? '');
    this.storageService.setSessionStorageItem('ShimanoLanguage', lang ?? '');
  }

  goToLogin(options: GoToLoginOptions = {}): boolean {
    const { isAsm = false, navigate = false } = options;
    const businessType = this.storageService.getSessionStorageItem('ShimanoBusinessType')?.toLowerCase();
    const country = this.storageService.getSessionStorageItem('ShimanoCountry')?.toLowerCase();
    const language = this.storageService.getSessionStorageItem('ShimanoLanguage')?.toLowerCase();

    if (!businessType || !country || !language) {
      if (navigate) {
        this.navigateToLogin();
      }
      return false;
    }

    const currentContext = `${businessType}|${country}|${language}`;
    const lastAuthorizeContext = this.storageService.getSessionStorageItem('lastAuthorizeContext');

    if (currentContext === lastAuthorizeContext) {
      if (navigate) {
        this.navigateToLogin();
      }
      return false;
    }

    this.storageService.setSessionStorageItem('lastAuthorizeContext', currentContext);

    if (isAsm) {
      this.storageService.removeSessionStorageItem('standardLoginTriggered');
      this.storageService.setSessionStorageItem('asmLoginTriggered', 'true');
    } else {
      this.storageService.removeSessionStorageItem('asmLoginTriggered');
      this.storageService.setSessionStorageItem('standardLoginTriggered', 'true');
    }

    if (navigate) {
      this.navigateToLogin();
    }
    return true;
  }

  private navigateToLogin(): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/login']);
    });
  }
}
